// extracted by mini-css-extract-plugin
export default {"root":"floatingLabel_root__nxre3","input":"floatingLabel_input__BgG3l","label":"floatingLabel_label__7A3sO","counter":"floatingLabel_counter__0wDuX"};